import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import AddOutletForm from "../../components/ManageOutlet/AddOutletForm";
import { ToastMessage } from "../../components/ToastMessage";
import Toggle from "../../components/Toggle";
import { uploadEventImage } from "../../services/eventsService";
import { Colors } from "../../config/Constants";
import { validateOutlet } from "./validateOutlet";
import {
  addOutlet,
  fetchOutletFromId,
  updateOutlet,
} from "../../services/outletsService";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { getAddOutletData, getFomattedOutletData } from "../../helper";
import { useLoadContext } from "../../contexts/LoadContext";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import InfoAndText from "../../components/ManageOutlet/InfoAndText";
import dayjs from "dayjs";
import { getSettings } from "../../services/settingsService";

interface StatusProps {
  status: boolean;
}

const AddOutlet = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(true);
  const [outletTags, setOutletTags] = useState([]);
  const [reservationStatus, setReservationStatus] = useState(false);
  const [isSevenRoomBooking, setIsSevenRoomBooking] = useState(true);
  const [isIFrameBooking, setIsIFrameBooking] = useState(false);
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [outletData, setOutletData] = useState({
    outletName: "",
    outletType: "",
    email: "",
    countryCode: "",
    phoneNumber: "",
    outletInfo: "",
    whatsappNumber: "",
    instaLink: "",
    fbLink: "",
    lat: "",
    long: "",
    address: "",
    shortName: "",
    tripAdvisor: "",
    sevenRoomWhatsapp: "",
    sevenRoomCountryCode: "",
    sevenRoomContact: "",
    maxGuest: "",
    venueId: "",
    logoUrl: new Array<string>(),
    imageUrl: new Array<string>(),
    bannerImageUrl: new Array<string>(),
    iFrameUrl: "",
    specialProductsDates: new Array<string>(),
    holidayAllowedDates: new Array<string>(),
    restrictedDates: new Array<string>(),
    startDate: "",
    endDate: "",
    isLoyaltyEnabled: false,
    loyaltyTypes: new Array<string>(),
    posConfigUrl: "",
    posConfigtenderMediaLoyalty: "",
    posConfigempId: "",
    posConfigrevCenter: "",
    notificationEmail: "",
    surveyLink: "",
    receiptMerchantName: "",
    tags: new Array<string>(),
    costCenter: "",
    companyCode: "",
    tcLink: "",
    ppLink: "",
    order: "",
    taxType: "",
    trn: "",
    tin: "",
    groupTrn: "",
    crNumber: "",
    taxStartDate: "",
    isInclusiveVAT: true,
    isTaxEnabled: false,
  });
  const [error, setError] = useState({
    outletName: "",
    outletType: "",
    email: "",
    countryCode: "",
    phoneNumber: "",
    outletInfo: "",
    whatsappNumber: "",
    instaLink: "",
    fbLink: "",
    lat: "",
    long: "",
    address: "",
    shortName: "",
    tripAdvisor: "",
    sevenRoomWhatsapp: "",
    sevenRoomContact: "",
    maxGuest: "",
    venueId: "",
    logoUrl: "",
    imageUrl: "",
    bannerImageUrl: "",
    iFrameUrl: "",
    specialProductsDates: "",
    holidayAllowedDates: "",
    restrictedDates: "",
    startDate: "",
    endDate: "",
    posConfigtenderMediaLoyalty: "",
    posConfigUrl: "",
    posConfigempId: "",
    posConfigrevCenter: "",
    loyaltyTypes: "",
    notificationEmail: "",
    surveyLink: "",
    tags: "",
    costCenter: "",
    companyCode: "",
    receiptMerchantName: "",
    tcLink: "",
    ppLink: "",
    order: "",
    taxType: "",
    trn: "",
    tin: "",
    groupTrn: "",
    crNumber: "",
    taxStartDate: "",
    isInclusiveVAT: "",
    isTaxEnabled: "",
  });
  const [uploadedImage, setUploadedImage] = useState();
  const { setLoader } = useLoadContext();
  const [taxConfigList, setTaxConfigList] = useState([]);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    let settings = await getSettings("cms");
    setOutletTags(
      settings?.data?.data?.outlet_tags?.map((item: any) => ({
        label: item?.value,
        value: item?.key,
      }))
    );

    let configObj = settings?.data?.data?.tax_type?.map((item: any) => ({
      label: item?.value,
      value: item?.key,
    }));

    configObj.unshift({
      value: "",
      label: "Select Config",
    });

    setTaxConfigList(configObj);
  };

  const uploadEvent = (event: any) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(event.target.files[0]);
    img.onload = async () => {
      if (
        event.target.name === "logoUrl" &&
        event.target.files[0].size > 2048756
        // ||
        // img.width > 512 ||
        // img.height > 512
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          }
        );
      } else if (
        event.target.name === "imageUrl" &&
        event.target.files[0].size > 2048756
        // ||
        // img.width > 672 ||
        // img.height > 378
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          }
        );
      } else if (
        event.target.name === "bannerImageUrl" &&
        event.target.files[0].size > 2048756
        //  ||
        // img.width > 327 ||
        // img.height > 106
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          }
        );
      } else {
        try {
          let { data } = await uploadEventImage(event.target.files[0]);
          setUploadedImage(data.files[0]);
          let formData = { ...outletData };
          let formError = { ...error };
          if (event.target.name === "logoUrl") {
            //@ts-ignore
            formData["logoUrl"].push(data.files[0]);
            //@ts-ignore
            formError["logoUrl"] = "";
          }
          if (event.target.name === "imageUrl") {
            //@ts-ignore
            formData["imageUrl"].push(data.files[0]);
            //@ts-ignore
            formError["imageUrl"] = "";
          }
          if (event.target.name === "bannerImageUrl") {
            //@ts-ignore
            formData["bannerImageUrl"].push(data.files[0]);
            //@ts-ignore
            formError["bannerImageUrl"] = "";
          }
          setOutletData(formData);
          setError(formError);
        } catch (error: any) {
          toast.error(<ToastMessage message="File cannot be uploaded." />, {
            hideProgressBar: true,
          });
        }
      }
    };
  };

  const handleChange = async (event: any) => {
    if (
      event.target.name === "logoUrl" ||
      event.target.name === "imageUrl" ||
      event.target.name === "bannerImageUrl"
    ) {
      uploadEvent(event);
    } else if (
      event.target.name === "tcLink" ||
      event.target.name === "ppLink"
    ) {
      if (event.target?.files?.length > 0) {
        setLoader(true);
        try {
          let formData = { ...outletData };
          let formError = { ...error };
          let { data } = await uploadEventImage(event.target.files[0]);
          //@ts-ignore
          formData[event.target.name] = data?.files[0].viewUrl;
          //@ts-ignore
          formError[event.target.name] = "";
          setOutletData(formData);
          setError(formError);
        } catch (err: any) {
          toast.error(err?.message);
        } finally {
          setLoader(false);
        }
      } else {
        let formData = { ...outletData };
        let formError = { ...error };
        //@ts-ignore
        formData[event.target.name] = "";
        //@ts-ignore
        formError[event.target.name] = "";
        setOutletData(formData);
        setError(formError);
      }
    } else if (
      event.target.name === "specialProductsDates" ||
      event.target.name === "holidayAllowedDates" ||
      event.target.name === "restrictedDates"
    ) {
      let res = event?.target?.value?.map((val: any) =>
        dayjs(val).format("YYYY/MM/DD")
      );
      let formData = { ...outletData };
      let formError = { ...error };
      //@ts-ignore
      formData[event.target.name] = res;
      //@ts-ignore
      formError[event.target.name] = "";
      setOutletData(formData);
      setError(formError);
    } else if (event.target.name === "isTaxEnabled") {
      let formData = { ...outletData };
      let formError = { ...error };
      //@ts-ignore
      formData[event.target.name] = event.target.value;

      formData["isInclusiveVAT"] = true;
      formData["taxStartDate"] = "";
      formData["trn"] = "";
      formData["crNumber"] = "";
      formData["groupTrn"] = "";
      formData["tin"] = "";
      formData["taxType"] = "";

      //@ts-ignore
      formError[event.target.name] = "";
      setOutletData(formData);
      setError(formError);
    } else {
      let formData = { ...outletData };
      let formError = { ...error };
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      //@ts-ignore
      formError[event.target.name] = "";
      setOutletData(formData);
      setError(formError);
    }
  };

  const handleCancel = () => {
    setIsCancelModal(true);
  };

  const handleSubmit = () => {
    if (
      !validateOutlet(outletData, setError, isSevenRoomBooking, isIFrameBooking)
    ) {
      setError({
        outletName: "",
        outletType: "",
        email: "",
        countryCode: "",
        phoneNumber: "",
        outletInfo: "",
        whatsappNumber: "",
        instaLink: "",
        fbLink: "",
        lat: "",
        long: "",
        address: "",
        shortName: "",
        tripAdvisor: "",
        sevenRoomWhatsapp: "",
        sevenRoomContact: "",
        maxGuest: "",
        venueId: "",
        logoUrl: "",
        imageUrl: "",
        bannerImageUrl: "",
        iFrameUrl: "",
        specialProductsDates: "",
        holidayAllowedDates: "",
        restrictedDates: "",
        startDate: "",
        endDate: "",
        posConfigtenderMediaLoyalty: "",
        posConfigUrl: "",
        posConfigempId: "",
        posConfigrevCenter: "",
        loyaltyTypes: "",
        notificationEmail: "",
        surveyLink: "",
        tags: "",
        costCenter: "",
        companyCode: "",
        receiptMerchantName: "",
        tcLink: "",
        ppLink: "",
        order: "",
        taxType: "",
        trn: "",
        tin: "",
        groupTrn: "",
        crNumber: "",
        taxStartDate: "",
        isInclusiveVAT: "",
        isTaxEnabled: "",
      });
      if (id) {
        updateData(
          getAddOutletData(
            outletData,
            status,
            reservationStatus,
            isSevenRoomBooking,
            isIFrameBooking
          )
        );
      } else {
        saveData(
          getAddOutletData(
            outletData,
            status,
            reservationStatus,
            isSevenRoomBooking,
            isIFrameBooking
          )
        );
      }
    }
  };

  const saveData = async (data: any) => {
    try {
      let response = await addOutlet(data);
      if (response.status === 201) {
        setIsSuccessModal(true);
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };
  const updateData = async (data: any) => {
    try {
      let response = await updateOutlet(data, id);
      if (response.status === 200) {
        setIsSuccessModal(true);
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleToggle = () => {
    setStatus(!status);
  };

  const removeImage = (e: any) => {
    let formData = { ...outletData };
    let formError = { ...error };
    //@ts-ignore
    formData.imageUrl = formData.imageUrl.filter((each) => each.viewUrl !== e);
    //@ts-ignore
    formData.logoUrl = formData.logoUrl.filter((each) => each.viewUrl !== e);
    formData.bannerImageUrl = formData.bannerImageUrl.filter(
      //@ts-ignore
      (each) => each.viewUrl !== e
    );
    setOutletData(formData);
    setError(formError);
    setUploadedImage(undefined);
  };

  useEffect(() => {
    if (id) {
      fetchOutletDetails(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchOutletDetails = async (id: string) => {
    setLoader(true);
    try {
      let { data } = await fetchOutletFromId(id);
      if (data.code === 200) {
        setLoader(false);
        setOutletData(getFomattedOutletData(data.data));
        setStatus(data.data.isActive);
        setReservationStatus(!data.data.disableReservation);
        setIsSevenRoomBooking(data.data.isSevenRoomBooking);
        setIsIFrameBooking(data.data.isWebBooking);
      }
    } catch (error: any) {
      setLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleLoyaltyTypeChange = (val: string) => {
    let loyaltyTypes = [...(outletData?.loyaltyTypes || [])];

    const exclusiveTypes = ["manual", "pos", "scan"];

    const isExclusive = exclusiveTypes.includes(val);
    const isSelected = loyaltyTypes.includes(val);

    if (isSelected) {
      loyaltyTypes = loyaltyTypes.filter((type) => type !== val);
    } else {
      if (isExclusive) {
        loyaltyTypes = loyaltyTypes.filter(
          (type) => !exclusiveTypes.includes(type)
        );
      }
      loyaltyTypes.push(val);
    }
    setOutletData((prev) => ({
      ...prev,
      loyaltyTypes,
    }));
    setError({
      ...error,
      loyaltyTypes: "",
      posConfigempId: "",
      posConfigtenderMediaLoyalty: "",
      posConfigUrl: "",
      posConfigrevCenter: "",
      notificationEmail: "",
    });
  };

  const handleToggleAllTags = () => {
    const isAllSelected = outletData.tags.length === outletTags.length;
    if (isAllSelected) {
      setOutletData({
        ...outletData,
        tags: [],
      });
    } else {
      setOutletData({
        ...outletData,
        tags: outletTags.map((opt: any) => opt.value),
      });
    }
    setError((prevData) => ({
      ...prevData,
      tags: "",
    }));
  };

  const handleToggleTagsOption = (value: any) => {
    let prev = outletData.tags || [];
    setOutletData({
      ...outletData,
      tags: prev.includes(value)
        ? prev.filter((val) => val !== value)
        : [...prev, value],
    });
    setError((prevData) => ({
      ...prevData,
      tags: "",
    }));
  };

  return (
    <>
      <StyledDiv>
        <StyledPageHeader>{id ? "Edit " : "Add "} Outlet</StyledPageHeader>
        <InfoWrapper>
          <InfoAndText text="(This toggle is to activate and deactivate the Outlet)" />
          <StyledStatus>
            Status:
            <Toggle
              uniqueName={"status"}
              isChecked={status}
              onChange={handleToggle}
            />
            <ActiveDeactive status={status}>
              {status ? "Active" : "Inactive"}
            </ActiveDeactive>
          </StyledStatus>
        </InfoWrapper>
      </StyledDiv>
      <AddOutletForm
        id={id}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        onChange={handleChange}
        onRemove={removeImage}
        error={error}
        value={outletData}
        taxConfigList={taxConfigList}
        uploadedImage={uploadedImage}
        reservationStatus={reservationStatus}
        reservationToggle={() => setReservationStatus(!reservationStatus)}
        isSevenRoomBooking={isSevenRoomBooking}
        setIsSevenRoomBooking={setIsSevenRoomBooking}
        isIFrameBooking={isIFrameBooking}
        setIsIFrameBooking={() => setIsIFrameBooking(!isIFrameBooking)}
        setIfLoyaltyEnabled={() => {
          setOutletData({
            ...outletData,
            isLoyaltyEnabled: !outletData.isLoyaltyEnabled,
          });
        }}
        onLoyaltyTypeChange={handleLoyaltyTypeChange}
        outletTags={outletTags}
        onToggleSelectAllTags={handleToggleAllTags}
        onToggleTagOption={handleToggleTagsOption}
        onSetUrls={(items: any) => {
          setOutletData({
            ...outletData,
            imageUrl: items,
          });
        }}
      />
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
      {isSuccessModal && (
        <ErrorSuccessModal
          variant="success"
          heading="Outlet details saved successfully."
          buttonLabel="Ok"
          setOpenOrClose={setIsSuccessModal}
          onSubmit={() => {
            setIsSuccessModal(false);
            navigate("/admin/manage-outlet");
          }}
        />
      )}
      {isCancelModal && (
        <ConfirmModal
          heading="Are you sure you want to leave ?"
          subHeading="Hey there! It looks like you're in the middle of something and you haven't saved all of your content. Save before you go!"
          button2Label="Save"
          button1Label="Leave"
          button1Submit={() => {
            setIsCancelModal(false);
            navigate("/admin/manage-outlet");
          }}
          button2Submit={() => {
            setIsCancelModal(false);
          }}
          setOpenOrClose={setIsCancelModal}
        />
      )}
    </>
  );
};

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
export const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

interface Props {
  disabled?: boolean;
}

export const InfoWrapper = styled.div<Props>`
  display: flex;
  align-items: center;
  gap: 1rem;
  opacity:  ${(props) => (props.disabled ? '0.5' : '1')};
  @media only screen and (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    margin: 1.5625rem 1.5625rem 0 1.5625rem;
  }
`;
export const StyledStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.8125rem;
`;
export const ActiveDeactive = styled.div<StatusProps>`
  color: ${(props) => (props.status ? Colors.appleGreen : Colors.appleRed)};
  width: 6rem;
`;

export default AddOutlet;
